"use client";

import { Button, Tooltip } from "@mui/material";
import { VerifiedUser } from "@mui/icons-material";

import { useOpenAccount } from "@/context/openAccount";
import { useRecaptcha } from "@/context/util/recaptcha";

import StepButtonWrapper from "@/components/wrapper/stepButton";

export default function SetupButton() {
  const { showV2 } = useRecaptcha();
  const { errors, openAccountUser, setupAccount } = useOpenAccount();

  const hasErrors =
    Object.keys(errors).length > 0 ||
    !openAccountUser?.pin ||
    !openAccountUser?.password?.length ||
    !openAccountUser?.securityQuestion?.id?.length ||
    !openAccountUser?.securityQuestion?.answer?.length;

  function getTooltip() {
    if (hasErrors) {
      return "Please complete and validate all fields to finish account setup";
    } else if (showV2) {
      return "Please complete the reCAPTCHA to finish account setup";
    }
    return "Click to finish account setup";
  }

  return (
    <StepButtonWrapper
      button={
        <Tooltip title={getTooltip()}>
          <span>
            <Button
              disabled={hasErrors || showV2}
              onClick={setupAccount}
              sx={{
                height: 48,
                padding: "1em 3em",
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
              startIcon={<VerifiedUser />}
              variant="contained"
            >
              Complete
            </Button>
          </span>
        </Tooltip>
      }
    />
  );
}
